/**
 * @file Collapse 折叠面板
 * @description 高度动画展开/收起内容区；Menu 子菜单等同源实现。
 *
 * @whenToUse 侧栏子菜单、图纸目录分组、任意需平滑收起的区块。
 * @whenNotToUse 整页路由切换（用 Tabs）；树节点勾选（用 Tree）。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type CollapseProps = {
  /** 是否展开 */
  open: boolean
  /** 折叠内容 */
  children: ReactNode
  className?: string
}

/**
 * 折叠面板：`grid-template-rows` 高度动画 + 透明度过渡（布局层例外，见 ui-rules §3 布局）。
 */
export function Collapse({ open, children, className }: CollapseProps) {
  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows] duration-200 ease-out',
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        className,
      )}
      aria-hidden={!open}
    >
      <div
        className={cn(
          'overflow-hidden transition-opacity duration-200 ease-out',
          open ? 'opacity-100' : 'opacity-0',
        )}
      >
        {children}
      </div>
    </div>
  )
}
